<template lang="pug">
  div(
    :class="[$style.container, {[$style.formSubmitted] : formSubmitted}]"
    id="iolp-container")
    div(:class="$style.containerContent")
      div(:class="$style.modalHeader")
        div(:class="$style.headerContent")
          div(@click="close")
            Icon.text-body(
              name="i:chevron-left"
              :size="24")
          div(:class="$style.headerText")
            h1 {{ $t('items.title') }}
            p {{ $t('items.route', { from: furniture_getRouteFrom, to: furniture_getRouteTo }) }}
          div(
            :class="$style.phoneIcon"
            @click="triggerCallUs"
            qa-tag="item-call-us-open-btn")
            img(
              src="~/assets/img/chat_talk.svg"
              alt="Chat with us"
              width="40"
              height="40")
      div(:class="[$style.contentWrapper, 'overflow-y-hidden lg:overflow-y-visible']")
        div(:class="[$style.modalContent, {[$style.extendContent]: !openSection.name}]")
          //LazyMoveSearch(
          //  v-if="isMobile || (!openSection.name || openSection.name === 'search')"
          //  @open-search="setSearchOpen"
          //  @edit-item="openCreateItem")
          div(:class="$style.fakeSearch")
            TxtRefined(
              :placeholder="$t('items.search_title')"
              @focus="openSearch"
              :icon-left="'i:search-find'"
              :icon-size="24"
              icon-color="#41a5dd"
              autocomplete="one-time-code"
              background-color="white"
              qa-tag="item-search-btn")
          template(v-if="isMobile || !openSection.name")
            p {{ $t('items.categories') }}:
            div(:class="$style.cardContainer")
              div(
                v-for="(itemCategory, index) in itemCategories"
                :key="`${index}`"
                @click="openItemCategory(itemCategory, index.includes(' ') ? index.split(' ')[0] : index)")
                template(v-if="FURNITURE_DEFAULT_INVENTORY[itemCategory.item_tag_id]")
                  Icon.text-blue-primary(
                    :name="'i:' + FURNITURE_DEFAULT_INVENTORY[itemCategory.item_tag_id].icon"
                    :size="isMobile ? 32 : 48")
                  p {{index.includes(' ') ? index.split(' ')[0] : index}}
              div(@click="openCreateItem()")
                Icon.text-blue-primary(
                  :name="'i:' + FURNITURE_OTHER_TYPE.icon"
                  :size="isMobile ? 32 : 48")
                p {{ $t('items.custom') }}
          template(v-if="isMobile")
            LazyModal(
              v-if="openMoveItemModal"
              :show-close="false"
              :transition="false"
              size="auto"
              no-padding
              sub-modal)
              LazyMoveItems(
                :label="openSection.label"
                :title="FURNITURE_DEFAULT_INVENTORY[openSection.details.item_tag_id].title"
                :items="getItems(openSection.details)"
                :is-mobile="isMobile"
                @close="closeItemCategory")
            LazyModal(
              v-if="openSearchModal"
              :show-close="false"
              :transition="false"
              size="auto"
              no-padding
              sub-modal)
              LazyMoveSearchV2(
                @create-item="openCreateItem"
                @close="closeSearch")
            LazyModal(
              v-if="openSummaryModal"
              :show-close="false"
              size="auto"
              no-padding
              sub-modal)
              LazyMoveSummary(
                :is-edit-open="openEditModal"
                :form-submitted="formSubmitted"
                :is-mobile="isMobile"
                @edit-item="openEditItem"
                @close="toggleSummary")
            LazyModal(
              v-if="openEditModal"
              :show-close="false"
              :transition="false"
              size="auto"
              no-padding
              sub-modal)
              LazyEditItem(
                :is-mobile="isMobile"
                :original-item="originalItem"
                @submit-modal="submitModal"
                @close="closeEditItem")
          // Add here V1 code for desktop - before 8th of April
          // template(v-else)

          LazyModal(
            v-if="openCallUsModal"
            :show-close="false"
            :transition="false"
            size="auto"
            no-padding
            sub-modal)
            LazyCallUs(@close="closeCallUs")
        div(
          v-if="!isMobile"
          :class="$style.summaryAndFooter")
          LazyMoveSummary(
            :is-edit-open="openSection.name === 'edit'"
            :class="$style.moveSummaryDesktop"
            :is-mobile="false"
            @edit-item="openEditItem")
          div(:class="$style.modalFooter")
            div(:class="$style.truckContainerDesktop")
              AnyVanAnimatedVanIcon(:counter="furniture_getItemsCount")
            Btn(
              @click="submitForm"
              :disabled="furniture_getItemsCount === 0 || formSubmitted"
              size="l"
              kind="red"
              :block="true"
              :loading="formSubmitted"
              :icon-right="'i:chevron-right'") {{ $t('items.submit') }}
      CartFooter.safari-scroll-locked(
        v-if="isMobile"
        id="iolp-footer"
        :summary-opened="openSummaryModal"
        :class="{[$style.moveToTop]: isMobile && (openSection.name !== 'call-us' && openSection.name !== 'edit')}"
        :form-submitted="formSubmitted"
        @toggle-summary="toggleSummary"
        @submit-form="submitForm")
</template>

<script lang="ts">
import { defineComponent } from "vue"
import { mapGetters } from "vuex"
import { FURNITURE_DEFAULT_INVENTORY, FURNITURE_OTHER_TYPE } from "~/constants/item"
import {
  GET_ITEMS_COUNT,
  ADD_ITEM,
  UPDATE_ITEM,
  GET_ROUTE_FROM,
  GET_ROUTE_TO
  // IS_VALID_PICKUP,
  // IS_VALID_DELIVERY,
  // GET_PICKUP_ADDRESS,
  // GET_DELIVERY_ADDRESS
} from "~/store/listing"
import type { Item } from "~/models/item/item"

export default defineComponent({
  name: "FurnitureItemsModal",
  props: {
    isMobile: {
      type: Boolean,
      default: true
    },
    itemCategories: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
      originalItem: null as Item | null,
      formSubmitted: false,
      openSection: {
        name: null as string | null,
        label: null as string | null,
        details: {} as Record<string, any>
      },
      // distance: null,
      // duration: null,
      openSummaryModal: false,
      openEditModal: false,
      openCallUsModal: false,
      openMoveItemModal: false,
      openSearchModal: false
    }
  },

  computed: {
    FURNITURE_DEFAULT_INVENTORY() {
      return FURNITURE_DEFAULT_INVENTORY
    },
    FURNITURE_OTHER_TYPE() {
      return FURNITURE_OTHER_TYPE
    },
    ...mapGetters("listing", {
      furniture_getRouteFrom: GET_ROUTE_FROM,
      furniture_getRouteTo: GET_ROUTE_TO,
      furniture_getItemsCount: GET_ITEMS_COUNT
      // furniture_isValidPickup: IS_VALID_PICKUP,
      // furniture_isValidDelivery: IS_VALID_DELIVERY,
      // furniture_getPickupAddress: GET_PICKUP_ADDRESS,
      // furniture_getDeliveryAddress: GET_DELIVERY_ADDRESS
    })
    // pickupCoords(): Coords | null {
    //   if (this.furniture_isValidPickup) {
    //     return (this.furniture_getPickupAddress as Address).coordinates
    //   }
    //   return null
    // },
    // deliveryCoords(): Coords | null {
    //   if (this.furniture_isValidDelivery) {
    //     return (this.furniture_getDeliveryAddress as Address).coordinates
    //   }
    //   return null
    // }
  },

  mounted() {
    this.$snowplow.trackIOLPButton(this.furniture_getItemsCount)
    document.body.style.overflow = "hidden"
    document.body.style.position = "relative"
    document.body.style.height = "100vh"
  },

  beforeUnmount() {
    document.body.style.overflow = "unset"
    document.body.style.position = "static"
    document.body.style.height = "auto"
  },

  methods: {
    setSearchOpen(value) {
      this.openSection.name = value ? "search" : null
    },
    close() {
      this.$emit("close-modal")
      this.$snowplow.trackCloseButton("iolp_main")
    },
    getItems(itemCategory): Item[] {
      const items = Object.assign({}, itemCategory.items)
      return Object.values(items)
    },
    submitForm() {
      let source = "iolp_main"
      if (this.openSummaryModal) {
        source = "iolp_summary"
      } else if (this.openSection.name === "category") {
        source = "iolp_category"
      } else if (this.openSection.name === "search") {
        source = "iolp_search"
      }

      this.formSubmitted = true
      this.$snowplow.trackCTAButton(source, this.furniture_getItemsCount)
      this.$emit("submit")
    },
    toggleSummary() {
      this.openSummaryModal = !this.openSummaryModal
      if (this.openSummaryModal) {
        let source = "iolp_main"
        if (this.openSection.name === "category") {
          source = "iolp_category"
        } else if (this.openSection.name === "search") {
          source = "iolp_search"
        }

        this.$snowplow.trackSummaryButton(source, this.furniture_getItemsCount)
      } else {
        this.$snowplow.trackCloseButton("iolp_summary", this.furniture_getItemsCount)
      }
    },
    closeItemCategory() {
      this.openMoveItemModal = false
      this.openSection.name = null
    },
    triggerCallUs() {
      this.openCallUsModal = true
      this.openSection.name = "call-us"
      this.$snowplow.trackCallUsOpen("icon Call us", "item-call-us-open-btn")
    },
    closeCallUs() {
      this.openCallUsModal = false
      this.openSection.name = null
      this.$snowplow.trackCloseButton("iolp_call_us", this.furniture_getItemsCount)
    },
    openItemCategory(itemCategory, itemCategoryLabel) {
      this.openMoveItemModal = true
      this.openSection.name = "category"
      this.openSection.label = itemCategoryLabel
      this.openSection.details = itemCategory
      this.$snowplow.trackCategoryButton(
        FURNITURE_DEFAULT_INVENTORY[itemCategory.item_tag_id].title,
        this.furniture_getItemsCount
      )
    },
    openCreateItem(item: Item | null = null) {
      this.openEditModal = true
      this.originalItem = item
      this.openSection.name = "edit"
      if (item) {
        this.$snowplow.trackCreateItemOpen(item.name, item.source)
      } else {
        this.$snowplow.trackCreateItemOpen("", "other_custom_item")
      }
    },
    openEditItem(item: Item | null = null) {
      this.openEditModal = true
      this.originalItem = item
      this.openSection.name = "edit"
      if (item) {
        this.$snowplow.trackEditItemOpen(item.item_id || item.name, item.quantity)
      } else {
        this.$snowplow.trackEditItemOpen("", 0)
      }
    },
    closeEditItem() {
      this.openEditModal = false
      this.originalItem = null
      this.openSection.name = null
    },
    openSearch() {
      this.openSearchModal = true
      this.openSection.name = "search"
      this.$snowplow.trackSearchButton(this.furniture_getItemsCount)
    },
    closeSearch() {
      this.openSearchModal = false
      this.openSection.name = null
    },
    async submitModal(item: Item) {
      let success = false
      let action = ""

      if (this.originalItem && this.originalItem.fake_id) {
        success = await this.$store.dispatch("listing/" + UPDATE_ITEM, item)
        action = "update"
      } else {
        success = await this.$store.dispatch("listing/" + ADD_ITEM, item)
        action = "add"
      }

      if (success) {
        this.closeEditItem()
      }
    }

    // updateDistance(distance) {
    //   this.distance = distance
    // },
    // updateDuration(duration) {
    //   this.duration = duration
    // }
  }
})
</script>

<style lang="css" module>
.container {
  @apply w-screen h-screen h-dvh bg-anyvan-semantic-neutral flex flex-col fixed top-0 left-0 text-black70 font-bold;

  z-index: 999;
}

.formSubmitted::before {
  @apply h-full w-full absolute;
  content: "";
  z-index: 9999;
}

.containerContent {
  @apply h-full grid;
  grid-template-rows: min-content auto min-content;
}

.contentWrapper {
  @apply grid border-t border-black20;
  grid-template-rows: auto min-content;

  &::after {
    height: 20px;
    content: "";
    display: block;
    background: rgb(0, 0, 0);
    background: linear-gradient(rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.06) 100%);
  }
}

.modalHeader {
  @apply px-ds-md w-full bg-white;

  .headerContent {
    @apply flex items-center py-ds-xxs h-ds-xxl;

    > div:first-child {
      @apply p-ds-sm -m-ds-sm cursor-pointer;
    }

    .headerText {
      @apply ml-ds-sm;

      p::first-letter {
        @apply uppercase;
      }
    }
    .phoneIcon {
      @apply ml-auto cursor-pointer;
    }
  }

  h1 {
    @apply text-rebrandSm leading-normal mb-ds-xxs;
  }

  p {
    @apply text-sm leading-normal;
  }
}

/* -20px margin and 20px padding is required here to fix the scrolling of .contentWrapper::after element */
.modalContent {
  @apply p-ds-md pb-ds-ml overflow-y-auto -mb-ds-ml;

  > p {
    @apply pb-ds-sm;
  }
}

.extendContent {
  @apply grid;
  grid-template-rows: min-content min-content auto;
}

.fakeSearch {
  @apply relative mt-ds-sm mb-ds-ml;

  :global(.text-input) input {
    @apply h-[56px] p-ds-md leading-2xl text-rebrandSm border-2 border-black20 rounded-[100px];
    padding-left: 52px !important;
  }
}

.cardContainer {
  @apply grid gap-ds-sm;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(3, min-content);

  > div {
    @apply flex flex-col justify-center items-center p-ds-sm border border-black20 rounded-lg bg-white text-center cursor-pointer;
    height: clamp(100px, 30vw, 35vw);
  }

  p {
    @apply text-sm leading-normal min-h-[34px] flex items-center;
  }
}

.routeData {
  @apply relative w-full text-gray-650 text-base leading-normal px-ds-md py-ds-md bg-gray-140;
}

.modalFooter {
  @apply w-full bg-white px-ds-md py-ds-md flex justify-between self-end h-auto border-t border-anyvan-grey-medium;

  .truckContainer {
    @apply flex mr-ds-sm items-center cursor-pointer;
  }

  .truckContainerDesktop {
    @apply hidden;
  }

  .chevronIcon {
    @apply ml-ds-xxxs mt-[-10px] self-start;
  }

  button {
    svg {
      @apply mr-ds-sm;
    }
  }
}

.moveToTop {
  z-index: 1000;
}

@screen lg {
  .container {
    @apply flex items-center;

    .moveSummaryDesktop {
      @apply h-full self-baseline border-x border-b border-black20 rounded-md;
    }
  }

  .modalHeader {
    @apply flex justify-center px-0 border-transparent;
  }

  .headerContent,
  .contentWrapper {
    @apply px-[80px] justify-self-center w-full;
  }

  .containerContent {
    @apply w-full gap-y-ds-xl;
  }

  .contentWrapper {
    @apply gap-y-ds-lg;
    max-height: calc(100vh - 177px);
    grid-template-columns: auto 400px;
    grid-template-rows: auto;
  }

  .headerText {
    @apply flex items-baseline gap-ds-md;

    h1 {
      @apply text-rebrandXm;
    }

    p {
      @apply text-base;
    }
  }

  .modalContent {
    @apply p-0;
    max-height: inherit;

    & > p {
      @apply pb-ds-md;
    }
  }

  .cardContainer {
    > div {
      height: 10em;
    }

    p {
      @apply text-rebrandSm;
    }
  }

  .summaryAndFooter {
    @apply grid gap-ds-md;
    grid-template-rows: auto min-content;
    max-height: inherit;
  }

  .modalFooter {
    @apply self-baseline p-0 border-0 bg-transparent;

    .truckContainer {
      @apply hidden;
    }

    .truckContainerDesktop {
      @apply flex relative mr-ds-lg items-center;
    }
  }
}

@screen xl {
  .contentWrapper,
  .headerContent {
    @apply px-ds-xxxl;
  }

  .contentWrapper {
    grid-template-columns: auto 440px;
    column-gap: 64px;
  }
}

@screen rebrandLg {
  .contentWrapper,
  .headerContent {
    @apply max-w-screen-rebrandLg;
  }
}
</style>
